

export function Education() {
  return (
    

    <ul className="education-list">
      <li>თბილისის სახელმწიფო სამედიცინო უნივერსიტეტი</li>
      <li>პრაქტიკა ნუტრიცილოლოგიაში</li>
    </ul>
  );
}